import React from 'react';
import PropTypes from 'prop-types';
import MemberAttributionSelect from '../MemberAttributionSelect';

const MemberAttributionFilter = ({ members, transactions, value, onChange }) => {
  return <MemberAttributionSelect id="movement-member-filter" label="Atribuição" members={members} transactions={transactions} value={value} onChange={onChange} filter compact />;
};
MemberAttributionFilter.propTypes = { members: PropTypes.array.isRequired, transactions: PropTypes.array.isRequired, value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };
export default MemberAttributionFilter;
